<template>
  <div style="margin-top:15px">
    <!-- 轮播图 -->
    <Carousel v-model="value" loop autoplay :autoplay-speed="5000">
      <CarouselItem>
        <img src="@/assets/banner-home.png" />
      </CarouselItem>
    </Carousel>
    <!-- 轮播图 -->
    <Row :gutter="24" style="margin-top:10px;">
      <Col :span="12">
        <Card :padding="60" shadow>
          <img src="@/assets/border-img-t-l.png" alt="" class="border-img border-top-left">
          <img src="@/assets/border-img-t-r.png" alt="" class="border-img border-top-right">
          <img src="@/assets/border-img-b-l.png" alt="" class="border-img border-bottom-left">
          <img src="@/assets/border-img-b-r.png" alt="" class="border-img border-bottom-right">
          <x-title title="游客指南"></x-title>
          <div class="head-title">公园售票时间</div>
          <div style="margin-left:98px;letter-spacing:2px;margin-bottom:5.5px;">旺季（4月1日至11月15日）6:00-18:30</div>
          <div style="margin-left:98px;letter-spacing:1.6px;margin-bottom:5.5px;">淡季（11月16日至3月31日）6:00-18:00</div>
          <div style="margin-left:98px;letter-spacing:1.6px;">(注:止票后1小时静园)</div>
          <div class="head-title">公园门票价格</div>
          <div style="width:62%;margin-left:98px;display:flex;justify-content:space-between;margin-bottom:5.5px;">
          	<div style="letter-spacing:10px;">旺季:</div>
          	<div style="width:95px;">全价门票10元</div>
          	<div style="width:90px;">优惠门票5元</div>
          </div>
          <div style="width:62%;margin-left:98px;display:flex;justify-content:space-between;">
          	<div style="letter-spacing:10px;">淡季:</div>
          	<div style="width:95px;">全价门票5元</div>
          	<div style="width:90px;">优惠门票2.5元</div>
          </div>
          <div class="head-title">景点售票时间</div>
          <div style="width:42%;margin-left:98px;display:flex;justify-content:space-between;margin-bottom:5.5px;">
          	<div style="letter-spacing:10px;">碧云寺:</div>
          	<div>
              <div>旺季8:00-17:00</div>
              <div>淡季8:30-16:30</div>
            </div>
          </div>
           <div style="margin-left:90px;letter-spacing:1px;">
                （因保护修缮，暂停开放）
            </div>
          <div style="width:42%;margin-left:98px;display:flex;justify-content:space-between;margin-bottom:5.5px;">
          	<div style="letter-spacing:5px;">双清别墅:</div>
          	<div>全年 9:00-16:00</div>
          </div>
          <!-- 2024-07-13 李德先通知 -->
          <!-- <div style="margin-left:98px;letter-spacing:1px;">(每周一闭馆，法定节假日除外)</div> -->
          <div class="head-title">景点门票价格</div>
          <div style="width:62%;margin-left:98px;display:flex;justify-content:space-between;margin-bottom:5.5px;">
          	<div style="letter-spacing:10px;">碧云寺:</div>
          	<div style="width:95px;">全价门票10元</div>
          	<div style="width:90px;">优惠门票5元</div>
          </div>
          <div style="width:47%;margin-left:98px;display:flex;justify-content:space-between;">
          	<div style="letter-spacing:4px;">双清别墅:</div>
          	<div>免费</div>
          </div>
          <!--<div class="head-title">公园开放时间</div>
          <Row :gutter="24" class="common-font">
            <Col :span="10">旺季（4月1日至11月15日）</Col>
            <Col :span="14">售票时间：6:00 止票时间：18:30</Col>
          </Row>
          <Row :gutter="24" class="common-font">
            <Col :span="14" :offset="10">(止票后1小时静园)</Col>
          </Row>
          <Row :gutter="24" class="common-font">
            <Col :span="10">淡季（11月16日至3月31日）</Col>
            <Col :span="14">售票时间：6:00 止票时间：18:00</Col>
          </Row>
          <Row :gutter="24" class="common-font">
            <Col :span="14" :offset="10">(止票后1小时静园)</Col>
          </Row>
          <div class="head-title">门票价格</div>
          <Row :gutter="24" class="common-font">
            <Col :span="4">旺季</Col>
            <Col :span="6">联票：15元</Col>
            <Col :span="6">优惠联票：7元</Col>
          </Row>
          <Row :gutter="24" class="common-font">
            <Col :span="6" :offset="4">门票：10元</Col>
            <Col :span="6">优惠门票：5元</Col>
          </Row>
          <Row :gutter="24" style="margin-top: 10px" class="common-font">
            <Col :span="4">淡季</Col>
            <Col :span="6">联票：14元</Col>
            <Col :span="6">优惠联票：7元</Col>
          </Row>
          <Row :gutter="24" class="common-font">
            <Col :span="6" :offset="4">门票：5元</Col>
            <Col :span="8">优惠门票：2.5元</Col>
          </Row>
          <Row :gutter="24" style="margin-top: 10px;margin-bottom:14px" class="common-font">
            <Col :span="8">景点票（全年）：</Col>
            <Col :span="8">碧云寺门票：10元</Col>
            <Col :span="8">碧云优惠门票：5元</Col>
            <Col :span="8">(周一闭馆)</Col>
          </Row>-->
        </Card>
      </Col>
      <Col :span="12">
        <Card  :padding="60" shadow>
          <img src="@/assets/border-img-t-l.png" alt="" class="border-img border-top-left">
          <img src="@/assets/border-img-t-r.png" alt="" class="border-img border-top-right">
          <img src="@/assets/border-img-b-l.png" alt="" class="border-img border-bottom-left">
          <img src="@/assets/border-img-b-r.png" alt="" class="border-img border-bottom-right">
          <x-title title="售票情况"></x-title>
          <div class="current-day">
            <div class="tour">
              <!-- {{tourIndex}} -->
              <div class="tour-index">游览指数 <span class="tour-status" v-if="currentDay">{{tourIndex}}</span></div>
              <div class="current-date">{{currentDay.date | currentTimeformat}}</div>
            </div>
            <div class="current-sale">
             <Row :gutter="24">
               <!-- <Col span="12" class="current-am"
                v-if="currentDay && currentDay.detailList && currentDay.detailList.length > 0">
                上午已售<span style="color:#fff">{{currentDay.detailList[0].saleCount}}</span></Col>
               <Col span="12" class="current-pm"
                v-if="currentDay && currentDay.detailList && currentDay.detailList.length > 1">
                下午已售<span style="color:#fff">{{currentDay.detailList[1].saleCount}}</span></Col> -->
                <Col span="12" class="current-am">
                  <Col span="4">上午</Col>
                  <Col span="10"  v-if="currentDay && currentDay.detailList && currentDay.detailList.length > 0">
                    <!-- <div>{{currentDay.detailList[0].beginTime}}-{{currentDay.detailList[0].endTime}}</div>
                    <div>{{currentDay.detailList[1].beginTime}}-{{currentDay.detailList[1].endTime}}</div> -->
                    <div>{{currentDay.detailList[0].playPeriodDisplay}}</div>
                    <div>{{currentDay.detailList[1].playPeriodDisplay}}</div>
                  </Col>
                  <Col span="10"  v-if="currentDay && currentDay.detailList && currentDay.detailList.length > 0">
                    <div>已售: {{currentDay.detailList[0].usedTotal - currentDay.detailList[0].cancelTotal}}</div>
                    <div>已售: {{currentDay.detailList[1].usedTotal - currentDay.detailList[1].cancelTotal}}</div>
                  </Col>
                </Col>
                <Col span="12" class="current-pm"  v-if="currentDay && currentDay.detailList && currentDay.detailList.length > 0">
                  <Col span="4">下午</Col>
                  <Col span="10">
                    <!-- <div>{{currentDay.detailList[2].beginTime}}-{{currentDay.detailList[2].endTime}}</div>
                    <div>{{currentDay.detailList[3].beginTime}}-{{currentDay.detailList[3].endTime}}</div> -->
                     <div>{{currentDay.detailList[2].playPeriodDisplay}}</div>
                    <div>{{currentDay.detailList[3].playPeriodDisplay}}</div>
                  </Col>
                  <Col span="10"  v-if="currentDay && currentDay.detailList && currentDay.detailList.length > 0">
                    <div>已售: {{currentDay.detailList[2].usedTotal - currentDay.detailList[2].cancelTotal}}</div>
                    <div>已售: {{currentDay.detailList[3].usedTotal - currentDay.detailList[3].cancelTotal}}</div>
                  </Col>
                </Col>
             </Row>
            </div>
          </div>
          <div>
            <div class="appiontment-person">购票人数</div>
            <Row>
              <Col span="8" class="little-center-line">较少</Col>
              <Col span="8" class="ordinary-center-line">一般</Col>
              <Col span="8" class="more-center-line">较多</Col>
            </Row>
            <Row style="margin-top:5px">
              <Col span="8" class="little-bgcolor"></Col>
              <Col span="8" class="ordinary-bgcolor"></Col>
              <Col span="8" class="more-bgcolor"></Col>
            </Row>
          </div>

          <div class="ticket-content">
            <div class="ticket1-item" v-for="(item,index) in data" :key="index">
                <p class="playDate">{{item.date | timeformat}}</p>
                <p class="AM">
                  <span style="margin-right:15px">上午已售</span><span :style="{'color': calcColor('am', item.detailList[0].saleCount)}" v-if="item.detailList.length != 0">{{item.detailList[0].saleCount}}</span>
                </p>
                <p class="PM" style="padding-top:0px">
                  <span style="margin-right:15px">下午已售</span><span :style="{'color': calcColor('pm', item.detailList[1].saleCount)}" v-if="item.detailList.length != 0">{{item.detailList[1].saleCount}}</span>
                </p>
            </div>
          </div>


          <Row style="margin-top:35px">
            <Col :span="colNum" style="text-align: center">
              <Button type="primary" v-if="userType === null || userType === '1'" style="width:120px;border-radius:8px;background:#54c2d9;border:none" @click="individualBuyTicket('company')">{{this.common.isLogin() ? '立即购票':'团体购票'}}</Button>
            </Col>
            <Col :span="colNum" style="text-align: center">
              <Button type="primary" v-if="userType === null || userType === '0'" style="width:120px;border-radius:8px" @click="individualBuyTicket('person')">{{this.common.isLogin() ? '立即购票':'散客购票'}}</Button>
            </Col>
            <Col :span="colNum" style="text-align: center">
            <!-- @click="sqbsBuyTicket()" -->
              <Button type="primary" style="width:120px;border-radius:8px" disabled>双清别墅</Button>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
    <Row style="margin-top:20px">
      <xs-notice></xs-notice>
    </Row>
    <Row style="margin-bottom:10px">
       <Notice></Notice>
    </Row>
    <!-- 登陆框 -->
    <Modal
          :value="showModal"
          :footer-hide="true"
          :closable="false"
          :mask-closable="false"
          class-name="vertical-center-modal">
          <p slot="header" style="height:40px;vartical-align:middle">
              <img src="img/logo.png" style="width:100px; height: 40px; vertical-align: middle;">
              <span style="margin-left:20px">* 扫码登录</span>
          </p>
          <div style="text-align:center;margin-bottom:20px">
              <Login @closeModal="closeModal" v-if="showModal"></Login>
          </div>
      </Modal>
    <!-- /登陆框 -->
    <!-- 提示框 -->
    <Modal v-model="tipsModal" width="360">
        <p slot="header" style="color:#f60;text-align:center">
            <Icon type="ios-information-circle"></Icon>
            <span>重要通知</span>
        </p>
        <div style="text-align:center">
            <p>因天气原因,香山景区及双清别墅将于7月11日下午,</p>
            <p>7月12日全天临时关闭!</p>
        </div>
        <div slot="footer">
            <Button type="error" size="large" long @click="tipsOk">我知道了</Button>
        </div>
    </Modal>
    <!-- 提示框 -->
    <!-- 淡旺季选择输入框 -->
     <Modal 
        v-model="SelectFlag"
        footer-hide
        :closable="false"
        >
       <Row style="margin: 20px 0;height:150px;display:flex;flex-direction:column;justify-content:space-around;">
            <Col :span="24" style="text-align:center">
              <Button type="primary"  style="width:80%" @click="buyTicket('WJ')">预约购买{{ModalMonth}}月{{ModalDate}}日之{{season == 'WJ' ? '前' : '后'}}门票</Button>
            </Col>
            <Col :span="24" style="text-align:center">
              <Button type="primary"  style="width:80%" @click="buyTicket('DJ')">预约购买{{ModalMonth}}月{{ModalDate}}日之{{season == 'WJ' ? '后' : '前'}}门票</Button>
            </Col>
          </Row>
    </Modal>
    <!-- /淡旺季选择输入框 -->
  </div>
</template>

<script>
import Vue from 'vue'
import api from '@/api'
import Warning from '@/components/information/warning/Index' // 提示组件
import Policy from '@/components/information/policy/Index' // 政策组件
import XsNotice from '@/components/information/xsnotice/Index' // 香山温馨提示界面
import Notice from '@/components/information/notice/Index' // 公告组件
import Login from '@/components/login/login.vue'
import xTitle from '@/components/xTitle/index'
import { postAction,httpAction } from '@/api/manage'
import moment from 'moment'
export default {
  inject: ['reload'],
  components: {
    // calendar,
    Login,
    Notice,
    Policy,
    Warning,
    XsNotice,
    'x-title': xTitle
  },
  data () {
    return {
      ModalMonth: '',
      ModalDate: '',
      value: 0,
      showModal: false,
      tipsModal: false,
      showButton: true,
      SelectFlag: false,
      resosurce:[],
      data: [],
      currentDay: [],
      salePeriodList:[],
      dwjDateObj:[],
      userType: null,
      ticketId: '',
      season: ''
    }
  },
  filters: {
    currentTimeformat: function (value) {
      if(!value) return ''
      if(value){
        let newValue = value.split("-")
        return newValue[0]+'年'+newValue[1]+'月'+newValue[2]+'日'
      }
    },
    timeformat: function (value) {
      if(!value) return ''
      if(value){
        let newValue = value.split("-")
        return newValue[1]+'月'+newValue[2]+'日'
      }
    }
  },
  computed: {
    colNum () {
      const userType = this.userType
      if (userType) {
        return 12
      } else {
        return 8
      }
    },
    tourIndex () {
      // 获取今天日期
      const currentDay = this.currentDay
      // 如果今日无时段信息，则直接返回
      if(!currentDay.detailList){
        return "暂无"
      }
      
      // 计算上午时段
      if(currentDay.detailList[1].expiredFlag == false){
        const amTotal = (currentDay.detailList[0].usedTotal - currentDay.detailList[0].cancelTotal) +
          (currentDay.detailList[1].usedTotal - currentDay.detailList[1].cancelTotal)
        return this.calcText('am', amTotal)
      }
      // 计算下午时段
      if(currentDay.detailList[1].expiredFlag == true){
        const pmTotal = (currentDay.detailList[2].usedTotal - currentDay.detailList[2].cancelTotal) +
          (currentDay.detailList[3].usedTotal - currentDay.detailList[3].cancelTotal)
        return this.calcText('pm', pmTotal)
      }
    }
  },
  mounted () {
    this.resource = JSON.parse(window.localStorage.getItem('resource'))
    this.salePeriodList = JSON.parse(window.localStorage.getItem('salePeriodList'))
    // console.log(this.salePeriodList)
    if (this.salePeriodList == null || this.salePeriodList == undefined) {
      this.getNewPeriod()
      // console.log('111')
    }
    this.dwjDateObj = JSON.parse(window.localStorage.getItem('dwjDateObj'))
    this.getList()
  },
  updated() {
    const type = Vue.ls.get('type')
    this.$set(this, 'userType', type)
  },
  methods: {
    // 获取新版时段JSON
    async getNewPeriod () {
      const obj = {
        codes: ['salePeriodList'],
        dataLocationType: 'latest',
        tenantCode: 'XSGY'
        // appCode: 1,
        // version: 1,
        // parkId: 1
      }
      const res = await httpAction(api.newPeriodList, 'post', obj)
      const salePeriodList = res.data.codeInfos[0].describe
      // console.log(JSON.parse(salePeriodList))
      window.localStorage.setItem('salePeriodList', JSON.stringify(JSON.parse(salePeriodList)))
      this.salePeriodList = JSON.parse(window.localStorage.getItem('salePeriodList'))
    },
    // 计算游览指数
    calcText (currentPeriod, currentTotalCount) {
      console.log(currentPeriod, currentTotalCount);
      if (!this.resource) {
        return '暂无'
      }
      const level = this.resource[currentPeriod].level;
      if (level.low.min <= currentTotalCount && currentTotalCount <= level.low.max) {
        return '适宜'
      }
      if (level.normal.min <= currentTotalCount && currentTotalCount <= level.normal.max) {
        return '一般'
      }
      if (level.strong.min <= currentTotalCount && currentTotalCount <= level.strong.max) {
        return '拥挤'
      }
    },
    async getList () {
      for (let item of this.dwjDateObj) {
        if (item.isCrossYear == 'no') {
          const current = new Date()
          // console.log(new Date().getFullYear() + item.startDate)
          const beginDate = new Date()
          const endDate = new Date(new Date().getFullYear() + '-' + item.endDate)
          // console.log(current)
          // console.log(beginDate)
          // console.log(endDate)
          if (current >= beginDate && current <= endDate) {
            this.ticketId = item.ticketId
          }
        } else {
          const current = new Date()
          // console.log(new Date().getFullYear() + item.startDate)
          const beginDate = new Date(new Date().getFullYear() + '-' + item.startDate)
          const endDate = new Date((new Date().getFullYear() + 1) + '-' + item.endDate)
          // console.log(current)
          // console.log(beginDate)
          // console.log(endDate)
          if (current >= beginDate && current <= endDate) {
            this.ticketId = item.ticketId
          }
        }
        console.log(this.ticketId)
        // console.log(new Date().getFullYear())
        // console.log(moment(item.startDate) <= moment())
        // if (moment(item.startDate) <= moment() <= moment(item.endDate)) {
        //   console.log(item.ticketId)
        // }
      }
      const obj = {
        // scenicId: '',
        // scenicCode: '',
        // ticketId: '',
        // ticketCode: '',
        // isParent: true, // 必传
        // showDays: '7' // 必传 展示天数
        // ticketIdList: [this.ticketId]
        type: 'main'
      }
      const res = await httpAction(api.resourceList, 'post', obj)
      console.log(res)
      this.currentDay = res.data[0]
      let rlt = [];
      for (let item of res.data) {
        // 将4时段合并成2时段
        if (item.detailList.length == 4) {
          let newPeriod1 = {
            usedTotal: item.detailList[0].usedTotal + item.detailList[1].usedTotal,
            cancelTotal: item.detailList[0].cancelTotal + item.detailList[1].cancelTotal
          };
          let newPeriod2 = {
            usedTotal: item.detailList[2].usedTotal + item.detailList[3].usedTotal,
            cancelTotal: item.detailList[2].cancelTotal + item.detailList[3].cancelTotal,
          };
          let newItem = {
            date: item.date,
            detailList: [newPeriod1, newPeriod2]
          }
          rlt.push(newItem);
        } else {
          rlt.push(item);
        }
      }

      // 计算售卖数量
      for (let item of rlt) {
        for (let period of item.detailList) {
          period.saleCount = period.usedTotal - period.cancelTotal;
        }
      }

      // 换算时段
      for (let item of this.currentDay.detailList) {
        for (let period of this.salePeriodList) {
          if (item.code == period.playPeriodCode) {
            item.playPeriodDisplay = period.playPeriodDisplay
          }
        }
      }
      this.data = rlt;
      // this.currentDay = rlt[0]
      this.data.shift()
    },
    // 淡旺季切换代码begin
    individualBuyTicket (type) {
      // console.log(type)
      // console.log(this.currentDay)
      this.currentUserType = type
      const conf = {
        preDay: 7,
        dateRange: [{
          beginDate: '11-16',
          // beginDate: '11-15',
          // endDate: '03-31',
          type: 'dj'
        }, {
          beginDate: '04-01',
          // endDate: '11-14',
          type: 'wj'
        }]
      }

      const currentDate = this.currentDay.date
      // const currentDate = '2022-03-28'
      const djRange = conf.dateRange.filter(item => item.type == 'dj')[0]
      const wjRange = conf.dateRange.filter(item => item.type == 'wj')[0]
      const djPreDate = moment((new Date().getFullYear() + '-' + djRange.beginDate), 'YYYY-MM-DD').add(-(conf.preDay), 'd').format('YYYY-MM-DD')

      const wjPreDate = moment((new Date().getFullYear() + '-' + wjRange.beginDate), 'YYYY-MM-DD').add(-(conf.preDay), 'd').format('YYYY-MM-DD')
      // const crossYearWjPreDate = moment(((new Date().getFullYear() + 1) + '-' + wjRange.beginDate), 'YYYY-MM-DD').add(-(conf.preDay), 'd').format('YYYY-MM-DD')
      // console.log(currentDate)
      // console.log(djRange.beginDate)
      // console.log(wjRange.beginDate)
      // console.log('---------')
      console.log(new Date().getFullYear() + '-' + djRange.beginDate)
      // 淡季切旺季
      if (djPreDate <= currentDate && currentDate < (new Date().getFullYear() + '-' + djRange.beginDate)) {
        this.SelectFlag = true
        this.ModalMonth = djRange.beginDate.split('-')[0]
        this.ModalDate = djRange.beginDate.split('-')[1]
        this.season = 'WJ'
        return
      }
      // 旺季切淡季
      if (wjPreDate <= currentDate && currentDate < (new Date().getFullYear() + '-' + wjRange.beginDate)) {
        this.SelectFlag = true
        this.ModalMonth = wjRange.beginDate.split('-')[0]
        this.ModalDate = wjRange.beginDate.split('-')[1]
        this.season = 'DJ'
        return
      }
      // console.log(wjRange.beginDate)
      // console.log(currentDate)
      // console.log(djPreDate)
      // console.log((new Date().getFullYear() + '-' + wjRange.beginDate) <= currentDate && currentDate <= djPreDate)
      // 旺季
      if ((new Date().getFullYear() + '-' + wjRange.beginDate) <= currentDate && currentDate <= djPreDate) {
        this.buyTicket('WJ')
        return
      }
      // 淡季
      if ((new Date().getFullYear() + '-01-01' <= currentDate && currentDate <= wjPreDate) || ((new Date().getFullYear() + '-' + djRange.beginDate) <= currentDate && currentDate <= new Date().getFullYear() + '-12-31')) {
        this.buyTicket('DJ')
        return
      }
      // console.log(wjPreDate)

      // 不提配置的写法
      // if ((new Date().getFullYear() + '-11-09') <= this.currentDay.date && this.currentDay.date < (new Date().getFullYear() + '-11-15')) {
      //   this.SelectFlag = true
      // }
      // if ((new Date().getFullYear() + '-03-26') <= this.currentDay.date && this.currentDay.date < (new Date().getFullYear() + '-04-01')) {
      //   this.SelectFlag = true
      // }
      // if ((new Date().getFullYear() + '-04-01') <= this.currentDay.date && this.currentDay.date <= (new Date().getFullYear() + '-11-09')) {
      //   this.buyTicket('WJ')
      // }
      // if ((new Date().getFullYear() + '-11-15') <= this.currentDay.date && this.currentDay.date <= ((new Date().getFullYear() + 1) + '-04-01')) {
      //   this.buyTicket('DJ')
      // }
    },
    buyTicket (season) {
      if (this.currentUserType === 'person') {
        const isRegister = Vue.ls.get('temporary')
        if (isRegister) {
          this.$Modal.confirm({
            title: '是否以散客身份继续购票？',
            onOk: () => {
              Vue.ls.remove('temporary')
              this.$router.push({ path: '/purchase/list', query: { user: this.currentUserType,season: season } })
            }
          })
        } else {
          this.$router.push({ path: '/purchase/list', query: { user: this.currentUserType,season: season } })
        }
      }
      this.$router.push({ path: '/purchase/list', query: { user: this.currentUserType,season: season } })
    },
    // 淡旺季切换代码end
    // individualBuyTicket (type) {
    //   if (type === 'person') {
    //     const isRegister = Vue.ls.get('temporary')
    //     if (isRegister) {
    //       this.$Modal.confirm({
    //         title: '是否以散客身份继续购票？',
    //         onOk: () => {
    //           Vue.ls.remove('temporary')
    //           this.$router.push({ path: '/purchase/list', query: { user: type } })
    //         }
    //       })
    //     } else {
    //       this.$router.push({ path: '/purchase/list', query: { user: type } })
    //     }
    //   }
    //   this.$router.push({ path: '/purchase/list', query: { user: type } })
    // },
    sqbsBuyTicket(){
      this.$router.push({ path: '/purchase/sqbslist'})
    },
    login () {
      this.showModal = true
      // console.log(this.showModal)
    },
    closeModal () {
      this.showModal = false
      this.reload()
      // console.log(this.showModal)
    } ,
    calcColor(period, saleCount){
      if(this.resource){
        let level = this.resource[period].level;
        if(level.low.min <= saleCount && saleCount <= level.low.max){
          return level.low.color
        }
        if(level.normal.min <= saleCount && saleCount <= level.normal.max){
          return level.normal.color
        }
        if(level.strong.min <= saleCount && saleCount <= level.strong.max){
          return level.strong.color
        }
      }
      return "#515a6e";
    },
    tipsOk () {
      this.tipsModal = false
    }
  }
}
</script>
<style>
.sale-ticke .ivu-card-body {
  background: url('../../../public/img/resource-bg.png') no-repeat;
}
</style>
<style scoped lang="less">
.layout-footer-center {
  text-align: center;
}
.ticket-title {
  display: flex;
  justify-content: center;
}
.ticket-content {
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
}
.ticket1-item {
  width: 29%;
  margin: 10px;
  text-align: center;
  // background-color: @container;
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
  /* padding: 10px; */
  // border-radius: 8px;
}
.buttom {
  text-align: center;
  margin-top: 0;
}
.buttom p {
  margin: 0;
  padding: 8px 8px 8px 8px;
}
.buy-btn-group {
  display: flex;
  justify-content: space-around;
}
  .head-title{
    width: 130px;
    margin: 20px auto 10px;
    font-size: 18px;
    color: #333;
    text-align: center;
    position: relative;
    font-weight: 600;
  }

  .head-title::before {
    content: '';
    position: absolute;
    left: -10px;
    top: calc(50% - 1px);
    width: 10px;
    height: 2px;
    background: #333;
  }

  .head-title::after {
    content: '';
    position: absolute;
    right: -10px;
    top: calc(50% - 1px);
    width: 10px;
    height: 2px;
    background: #333;
  }
  .current-day {
    margin: 30px auto 20px;
    background: #ed7457;
    padding: 10px;
    color: #fff;
  }
  .tour{
     position: relative;
  }
  .tour-index{
    font-size: 14px;
    // float: right;
    position:absolute;
    right: 0;
    margin-top: 5px;
    margin-right: 20px;
  }
  .tour-status{
    font-weight: 600;
  }
  .current-date{
    font-size: 20px;
    font-weight: 500;
    width:100%;
    text-align:center
  }
  // .current-am{
  //   padding-left:20px;
  //   font-weight:600;
  // }
  // .current-pm{
  //   padding-left:100px;
  //   border-left:2px solid #fff;
  //   font-weight:600;
  // }
  .current-am{
    text-align: center;
    font-weight:600;
    display: flex;
    align-items: center;
  }
  .current-pm{
    text-align: center;
    border-left:2px solid #fff;
    font-weight:600;
    display: flex;
    align-items: center;
  }
  .current-sale{
    margin-top: 5px;
  }
  .appiontment-person{
    float:left;
    position:absolute;
  }
  .little-center-line{
    text-align: center;
    color: #7acd48;
  }
  .ordinary-center-line{
    text-align: center;
    color: #fec750;
  }
  .more-center-line{
    text-align: center;
    color: #e87272;
  }
  .little-bgcolor{
    height: 10px;
    background: #7acd48;
  }
  .ordinary-bgcolor{
    height: 10px;
    background: #fec750;
  }
  .more-bgcolor{
    height: 10px;
    background: #e87272;
  }
  .common-font{
    line-height: 26px;
    font-size:14px;
  }
  .playDate{
    font-size: 18px;
    color: #333;
    margin-bottom: 10px;
  }
  .AM{
    font-size: 16px;
  }
  .PM{
    font-size: 16px;
  }
</style>